import { FC } from "react";
import { ContactDetails } from "./ContactDetails";
import { PaymentDetails } from "./PaymentDetails";
import { TermsAndConditions } from "./TermsAndConditions";

interface PersonalDetailsFormProps {
    setStripeComplete: React.Dispatch<React.SetStateAction<boolean>>
}

export const PersonalDetailsForm: FC<PersonalDetailsFormProps> = ({setStripeComplete}) => {

    return (
        <form id="personal-details-form" className="w-100 mr-13" onSubmit={e => e.preventDefault()}>
            <ContactDetails />
            <PaymentDetails setStripeComplete={setStripeComplete} />
            <TermsAndConditions />
        </form>
    )
}